import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleLogosBlock = ({
    heading,
    logoItems,
}) => {
    return (
        <section className='relative mt-40 mb-60 md:mt-60 md:mb-100'>
            <div className='layout-container'>
                <div className='layout-grid-negative-gutter sm:flex'>
                    <div className='sm:w-4/12 md:w-5/12' />

                    <div className='layout-grid-col-padding sm:w-8/12 md:w-7/12'>
                        <h2 className='type-style-3 pb-40 sm:pt-30'>
                            {heading}
                        </h2>

                        <figure className='flex flex-wrap gap-60'>
                            {logoItems?.map((item, idx) => {
                                return (
                                    <img
                                        alt={item.image.alt}
                                        className='h-60'
                                        key={idx}
                                        src={item.image.px2} />
                                );
                            })}
                        </figure>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    heading: PropTypes.string,
    logoItems: PropTypes.array,
};

ModuleLogosBlock.propTypes = propTypes;

export default ModuleLogosBlock;
